import { observable, computed, action } from 'mobx';
import { HistoryRecordDto, HistoryAction, ProjectImportSummary } from '../services/types';
import { HistoryHelpers } from '../misc';
import HistoryFieldModel from './HistoryFieldModel';

export default abstract class BaseHistoryRecordModel {
    static displayNameField = 'DisplayName';

    @observable
    readonly metaFields: HistoryFieldModel[] = [];

    readonly id: string;
    readonly projectId?: string;
    readonly entityId: string;
    readonly entityName: string;
    readonly objectName: string;
    readonly action: HistoryAction;
    readonly fields: HistoryFieldModel[];
    readonly userId: string;
    readonly userName: string;
    readonly createDate: string;
    readonly meta: unknown;
    readonly importOperationId?: string;
    readonly importSummary?: ProjectImportSummary;

    constructor(data: HistoryRecordDto) {
        this.id = data.id;
        this.projectId = data.projectId;
        this.entityId = data.entityId;
        this.entityName = data.entityName;
        this.objectName = data.objectName;
        this.action = data.action;
        this.fields = data.fields.map(field => new HistoryFieldModel(field));
        this.userId = data.userId;
        this.userName = data.userName;
        this.createDate = data.createDate;
        this.meta = data.meta;
        this.importOperationId = data.importOperationId;
        this.importSummary = data.importSummary;

        if (HistoryHelpers.hasNameMeta(this.meta) && this.meta.name.length) {
            this.setDisplayName(this.meta.name);
        }
    }

    @action
    setDisplayName(name: string) {
        this.metaFields.push(new HistoryFieldModel({ name: BaseHistoryRecordModel.displayNameField, value: name }));
    }

    @computed
    get displayName() {
        const displayName = this.metaFields.find(f => f.name === BaseHistoryRecordModel.displayNameField)?.value;
        return typeof displayName === 'string' ? displayName : null;
    }

    abstract get objectLabel(): string;
}
